export type MessagingStatus = 'ACTIVE' | 'SUSPENDED' | 'EXPIRED' | 'NOT_PAID'

type MessagingLike = {
  messagingPlan?: string | null
  messagingStartedAt?: string | null
  messagingNextRenewalAt?: string | null
  messagingSuspendedAt?: string | null
}

export function resolveMessagingStatus(owner: MessagingLike): MessagingStatus {
  if (owner.messagingSuspendedAt) return 'SUSPENDED'
  if (!owner.messagingNextRenewalAt) return 'NOT_PAID'

  const next = new Date(owner.messagingNextRenewalAt)
  if (Number.isNaN(next.getTime())) return 'NOT_PAID'

  if (next.getTime() <= Date.now()) return 'EXPIRED'
  return 'ACTIVE'
}

export function isMessagingActive(owner: MessagingLike): boolean {
  return resolveMessagingStatus(owner) === 'ACTIVE'
}
